import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import AccountPage from '../../modules/accounts/AccountPage'
import { AccountHeader } from '../../modules/accounts/AccountHeader'
import { Settings } from '../../modules/accounts/components/settings/Settings'
import { Overview } from '../../modules/accounts/components/Overview'
import { ResellerGroupsListWrapper } from './resellers-groups-list/ResellerGroupsList'

const resellergroupsBreadcrumbs: Array<PageLink> = [
  {
    title: 'ResellerGroup Management',
    path: '/admin/pages/resellergroups',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Account',
    path: '/admin/pages/resellergroups/overview',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const ResellerGroupsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          // path='resellergroups'
          index
          element={
            <>
              <PageTitle breadcrumbs={resellergroupsBreadcrumbs}>ResellerGroups list</PageTitle>
              <ResellerGroupsListWrapper />
            </>
          }
        />

        <Route
          element={
            <>
              <AccountHeader />
              <Outlet />
            </>
          }
        >
          <Route
            path='overview'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
                <Overview />
              </>
            }
          />
          <Route
            path='settings'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Settings</PageTitle>
                <Settings />
              </>
            }
          />
          <Route index element={<Navigate to='/admin/pages/resellergroups/overview' />} />
        </Route>

      </Route>
      <Route index element={<Navigate to='/admin/pages/resellergroups' />} />
    </Routes>
  )
}

export default ResellerGroupsPage
